<main class="main" [ngSwitch]="showRegister">
  <section *ngSwitchDefault>
    <img src="/assets/images/backgrounds/icon-success.png" alt="success-bg" />
    <h1>¡Registro Exitoso!</h1>
    <h2>
      Felicidades, has completado con éxito tu registro. ¡Te damos la
      bienvenida!
    </h2>
    <h3 class="title-web">
      Para brindarte la mejor experiencia posible, necesitamos saber más sobre
      tus intereses. Por favor, selecciona el o los productos que más te
      interese de la lista a continuación. Esto nos ayudará a personalizar tus
      comunicaciones y ofrecerte contenido relevante:
    </h3>
    <form
      class="m-t-30"
      [formGroup]="form"
      (ngSubmit)="submit(form.value)"
      *ngIf="!showForm"
    >
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>¿Cual es el producto de interés?</mat-label>
        <mat-select #select multiple formControlName="preference">
          <div class="select-all">
            <mat-checkbox
              [(ngModel)]="allSelected"
              [ngModelOptions]="{ standalone: true }"
              (change)="toggleAllSelection()"
              >Seleccionar Todos</mat-checkbox
            >
          </div>
          <mat-option
            (click)="optionClick()"
            *ngFor="let i of preferences"
            [value]="i.value"
          >
            {{ i.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!form.valid"
        class="w-100"
      >
        Enviar
      </button>
    </form>
  </section>
  <section *ngSwitchCase="1" class="main">
    <img src="/assets/images/backgrounds/question-icon.png" alt="success-bg" />
    <h1>Registro Incompleto</h1>
    <h3 class="title-web">
      Gracias por iniciar el proceso de registro con nosotros. Queremos
      asegurarnos de que obtengas la mejor experiencia posible,
      Para finalizar, por favor selecciona el o los productos que más te
      interese de la lista a continuación.
    </h3>
    <form
      class="m-t-30"
      [formGroup]="form"
      (ngSubmit)="submit(form.value)"
      *ngIf="!showForm"
    >
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>¿Cual es el producto de interés?</mat-label>
        <mat-select #select multiple formControlName="preference">
          <div class="select-all">
            <mat-checkbox
              [(ngModel)]="allSelected"
              [ngModelOptions]="{ standalone: true }"
              (change)="toggleAllSelection()"
              >Seleccionar Todos</mat-checkbox
            >
          </div>
          <mat-option
            (click)="optionClick()"
            *ngFor="let i of preferences"
            [value]="i.value"
          >
            {{ i.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!form.valid"
        class="w-100"
      >
        Enviar
      </button>
    </form>
  </section>
</main>
